import React, {useEffect, useState} from "react";
import ContainerLastUpdatedItem from "./ContainerLastUpdatedItem";
import {useDispatch, useSelector} from "react-redux";
import {getProjectHistory} from "./project-history/projectHistoryAction";
import styled from "styled-components";
import Loader from "../progress-bar/Loader";
import {v4 as uuidv4} from 'uuid';
import historySVG from "../../images/history.svg"
import {loadProject} from "../project/one-project/projectAction";
import {getDateInFrench2} from "../../utils/dateUtils";
import {getImage} from "../../utils/utils";
import Advancement from "../guided-update/guided-update-project/weather-and-advancement/Advancement";
import Weather from "../guided-update/guided-update-project/weather-and-advancement/Weather";
import accountSVG from "../../images/account.svg";

const ContainerHistoryUpdate = ({projectId}) => {

    const dispatch = useDispatch()
    const {isLoading, projectHistory} = useSelector(state => state.projectHistory)
    const  project = useSelector(state => state.project)
    const [selectedTab, setSelectedTab] = useState("info")

    useEffect(() => {
        if (projectId !== 0) {
            dispatch(getProjectHistory(projectId))
            dispatch(loadProject(projectId))
        }
    }, [dispatch, projectId])

    const statusFields = {
        project: "project",
        realTimeSpent: "realTimeSpent",
        realBudget: "realBudget",
        advancement: "advancement",
        weather: "weather",
        memberId: "memberId",
        success: "success",
        difficulties: "difficulties",
        team: "team",
        OKR: "OKR",
        actions: "action"
    }


    const lastUpdateItem =
        [
            {title: "Météo", field: statusFields.weather, entityClass: "Project"},
            {title: "Avancement", field: statusFields.advancement, entityClass: "Project"},
            {title: "Budget", field: statusFields.realBudget, entityClass: "Project"},
            {title: "Temps passé", field: statusFields.realTimeSpent, entityClass: "Project"},
            {title: "Équipe", field: statusFields.memberId, entityClass: "Project"},
            {title: "Objectif", field: statusFields.OKR, entityClass: "OKR"},
            {title: "Cailloux", field: statusFields.difficulties, entityClass: "Project"},
            {title: "Succès", field: statusFields.success, entityClass: "Project"},
            {title: "Actions", field: statusFields.actions, entityClass: "Action"}
        ]

    const getDateAndHourSectionDetails = (field, entityClass) => {
        // i take all the history according to the entity  class (Project, OKR or Actions)
        const entitySelected = projectHistory.filter(d => d.entityClass === entityClass)
        let dataByField
        if (entitySelected.length > 0) {
            if (entityClass === "Project") {
                dataByField = entitySelected.filter(d => d.modifiedField === field)[0]
            }
            if (entityClass === "Action" || entityClass === "OKR") {
                dataByField = [entitySelected[0]][0]
            }
            if (dataByField) {
                return {
                    date: dataByField.dateOfModification,
                    hour: dataByField.hourOfModification
                }
            } else {
                return {
                    date: 'Aucune modification',
                }
            }
        } else {
            return {
                date: 'Aucune modification',
            }
        }
    }
    const updateTab = () => {
        setSelectedTab("update")
    }

    const infoTab = () => {
        setSelectedTab("info")
    }
    const displayWelcomeContent =() => {
        if(selectedTab === "info"){
           return displayProjectInfo()
        }
        if(selectedTab === "update"){
            return displayHistoryUpdate()
        }
    }
    const displayProjectInfo = () => {
        if(isLoading) {
            return <Loader/>
        }
        else{
            return (
                <ThirdSection>
                    <DateContainer>
                        <p>Date de début : {getDateInFrench2(project.startDate)}</p>
                        <p>Date de fin : {getDateInFrench2(project.endDate)}</p>
                        <LastUpdate>Dernière mise à jour : {getDateInFrench2(project.lastUpdate)}</LastUpdate>

                    </DateContainer>
                    <SubSection>
                        <Weather fromWelcomeSection={true}/>
                        <Advancement fromWelcomeSection={true}/>
                    </SubSection>
                    <SubSection>
                        <div className={"subSectionItems"}>
                            <p>Pilote:</p>
                            <Pilot>
                                <ContainerImage>
                                    <img src={getImage(project.pilot.photo, accountSVG)} alt={project.pilot.firstName}/>
                                </ContainerImage>
                                <p>{project.pilot.firstName}</p>
                                <p>{project.pilot.lastName}</p>
                            </Pilot>
                        </div>
                        <div className={"subSectionItems"}>
                            <p>Commentaire:</p>
                            <textarea cols="50" rows="5" disabled={true}>{project.comment !== "" ? project.comment : "Aucun commentaire définit" }</textarea>
                        </div>
                    </SubSection>
                </ThirdSection>
            )
        }
    }
    const displayHistoryUpdate = () => {
        if (isLoading) {
            return <Loader/>
        } else {
            if (projectHistory.length === 0) {
                return (
                    <ThirdSection>
                        <p className={'txt-align w-100'}>
                            Ce projet n'a jamais été mis à jour !
                        </p>
                    </ThirdSection>
                )
            } else {
                return (
                    <ThirdSection>
                        <ul>

                            {
                                lastUpdateItem.map(item => (
                                    <li key={uuidv4()}>
                                        <ContainerLastUpdatedItem
                                            title={item.title}
                                            getDataByField={getDateAndHourSectionDetails}
                                            field={item.field}
                                            entityClass={item.entityClass}
                                        />
                                    </li>
                                ))
                            }
                        </ul>
                    </ThirdSection>
                )
            }
        }
    }
    return (
        <Container className={'container-history-update'}>
            <FirstSection>
                <Tab onClick={infoTab} className={selectedTab === "info" ? "tab-selected" : ""}>
                    <img src="" alt=""/>
                    <TabTitle>Informations actuelles du projet</TabTitle>
                </Tab>
                <Tab onClick={updateTab} className={selectedTab === "update" ? "tab-selected" : ""}>
                    <img src={historySVG} alt="historique"/>
                    <TabTitle >  Détails des modifications</TabTitle>
                </Tab>
            </FirstSection>
            <div>
                {displayWelcomeContent()}
            </div>
        </Container>
    )
}

const Container = styled.div`
  background-color: var(--color-white);
  display: flex;
  flex-direction: column;
  padding: 1rem;
  width: 100%;
  height: 100%;
`
const FirstSection = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-bottom: 0.5em;

`

const ThirdSection = styled.div`
  margin: 1em 0 1em 0;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0.5em;
  padding: 0.5rem;
`

const Tab = styled.div`
 display: flex;
  align-items: center;
  max-width: 50%;
  padding: 0.5rem;
  border-radius: 10px;
`

const TabTitle = styled.p`
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 700;
  text-align: center;
  padding-left: 0.5em;

`
const LastUpdate = styled.p`
  font-size: 18px;
  text-align: center;
`
const SubSection = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 900px){
      flex-direction: row;
      justify-content: space-around;
      margin-top: 1rem;
  }
    
    .subSectionItems{
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        width: 100%;
        align-items: center;
        
        @media screen and (min-width: 900px){
            width: 50%;
        } {
            
        }
    }
`

const Pilot = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  padding: 1rem;
  box-shadow: rgba(0,0,0,0.2) 0 6px 16px;
  max-width: 9em;
  p{
      text-align: center;
  }
`
const ContainerImage = styled.div`
  display: flex;
  align-items: center;
  min-width: 40px;
  max-width: 40px;
  min-height: 40px;
  max-height: 40px;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
`
const DateContainer = styled.div`

  display: flex;
  justify-content: space-evenly;
  gap: 2rem;
  border-radius: 10px;
  padding: 1rem 2rem;
  p{
    font-size: 14px;
  }
  
`
export default ContainerHistoryUpdate;